module.exports = __webpack_public_path__ + "img/contact.aa2905f8.svg";